import { CompactDialogContent } from '../../ui/CompactDialogContent.js';
import * as Dialog from '@radix-ui/react-dialog';
import { useRef, useState } from 'react';
import { useDianaUIPortal } from '../../ui/index.js';

export function DeleteClientDialog({
  name,
  linked,
  close,
  confirm,
}: {
  name: string;
  linked: number;
  close(): void;
  confirm(): Promise<void>;
}) {
  const portal = useDianaUIPortal();
  const gate = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return (
    <Dialog.Root
      open
      onOpenChange={(open) => {
        if (!open && !gate.current) close();
      }}
    >
      <Dialog.Portal container={portal}>
        <Dialog.Overlay className="shoot-destructive__overlay" />
        <CompactDialogContent
          title="Delete client?"
          description={
            <>
              {linked
                ? `${name} has ${linked} linked ${linked === 1 ? 'shoot' : 'shoots'}. Delete those shoots first. The client cannot be deleted while shoots are linked.`
                : `Delete ${name} and their contact details and notes? This cannot be undone.`}
            </>
          }
          onClose={close}
          busy={busy}
          footer={
            <div className="shoot-destructive__actions">
              <button
                className="shoot-button shoot-button--outline"
                disabled={busy}
                onClick={close}
              >
                {linked ? 'Close' : 'Cancel'}
              </button>
              {!linked ? (
                <button
                  className="shoot-button shoot-button--danger"
                  disabled={busy}
                  onClick={async () => {
                    if (gate.current) return;
                    gate.current = true;
                    setBusy(true);
                    setError('');
                    try {
                      await confirm();
                      close();
                    } catch {
                      setError(
                        'Could not delete. Refresh to check for changes or linked shoots before trying again.',
                      );
                    } finally {
                      gate.current = false;
                      setBusy(false);
                    }
                  }}
                >
                  {busy ? 'Deleting…' : 'Delete'}
                </button>
              ) : null}
            </div>
          }
        >
          {error ? <p role="alert">{error}</p> : null}
        </CompactDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
